import React from "react";

const ReminderMessageEditor = ({ reminder, error, onUpdate }) => {
    const isCustom = reminder.messageMode === "custom";

    return (
        <div className="reminder-message-editor">
            <div className="subsection-heading">
                <div>
                    <strong>
                        Reminder message
                    </strong>

                    <span>
                        Use our default message or
                        write your own.
                    </span>
                </div>
            </div>

            {/* MESSAGE MODE */}

            <div className="message-mode-options">
                <label
                    className={`message-mode-option ${ !isCustom ? "selected" : "" }`}
                >
                    <input
                        type="radio"
                        name={`message-mode-${reminder.id}`}
                        checked={!isCustom}
                        onChange={() =>
                            onUpdate({
                                messageMode: "default",
                                customMessage: "",
                            })
                        }
                    />

                    <div>
                        <strong>
                            Use default message
                        </strong>

                        <small>
                            We'll automatically create a professional payment reminder.
                        </small>
                    </div>
                </label>

                <label
                    className={`message-mode-option ${ isCustom ? "selected" : "" }`}
                >
                    <input
                        type="radio"
                        name={`message-mode-${reminder.id}`}
                        checked={isCustom}
                        onChange={() =>
                            onUpdate({
                                messageMode: "custom",
                            })
                        }
                    />

                    <div>
                        <strong>
                            Write custom message
                        </strong>

                        <small>
                            Create your own message for this reminder.
                        </small>
                    </div>
                </label>
            </div>

            {/* DEFAULT PREVIEW */}

            {!isCustom && (
                <div className="default-message-preview">
                    <span>
                        DEFAULT MESSAGE
                    </span>

                    <p>
                        Dear{" "}
                        <strong>{"{Client Name}"}</strong>
                        , this is a reminder regarding your payment of{" "}
                        <strong>{"{Currncy} {Amount}"}</strong>
                        {" "}for{" "}
                        <strong>{"{Payment Title}"}</strong>
                        . The payment is due on{" "}
                        <strong>{"{Due Date}"}</strong>
                        .
                    </p>
                </div>
            )}

            {/* CUSTOM MESSAGE */}

            {isCustom && (
                <div className="custom-message-area">
                    <textarea
                        value={ reminder.customMessage }
                        onChange={(e) =>
                            onUpdate({ customMessage: e.target.value })
                        }
                        placeholder={`Dear {{client_name}},

This is a friendly reminder regarding your payment of {{currency}} {{amount}}.

Payment due date: {{due_date}}

Pay here: {{payment_link}}`}
                        rows="6"
                        className={ error ? "input-error" : "" }
                    />

                    {error && (
                        <small className="field-error">
                            {error}
                        </small>
                    )}

                    <div className="message-editor-footer">
                        <span>
                            You can use variables such as:
                        </span>

                        <div className="variable-list">
                            <button
                                type="button"
                                onClick={() =>
                                    onUpdate({
                                        customMessage:
                                            `${
                                                reminder.customMessage
                                            }{{client_name}}`,
                                    })
                                }
                            >
                                {"{{client_name}}"}
                            </button>

                            <button
                                type="button"
                                onClick={() =>
                                    onUpdate({
                                        customMessage:
                                            `${
                                                reminder.customMessage
                                            }{{amount}}`,
                                    })
                                }
                            >
                                {"{{amount}}"}
                            </button>

                            <button
                                type="button"
                                onClick={() =>
                                    onUpdate({
                                        customMessage:
                                            `${
                                                reminder.customMessage
                                            }{{due_date}}`,
                                    })
                                }
                            >
                                {"{{due_date}}"}
                            </button>

                            <button
                                type="button"
                                onClick={() =>
                                    onUpdate({
                                        customMessage:
                                            `${
                                                reminder.customMessage
                                            }{{payment_link}}`,
                                    })
                                }
                            >
                                {"{{payment_link}}"}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ReminderMessageEditor;
